module.exports = __webpack_public_path__ + "img/logo_list3.0da0e6ff.png";